<script>
import ReportComponentVue from '@/app/arch/components/crud/components/ReportComponent.vue';

export default {
  name: 'ReportConfirmMangerModal',
  extends: ReportComponentVue,
  data: () => ({
    dialogTitle: 'O relatório foi para geração.',
    dialogText: 'Deseja abrir a tela de acompanhamento de relatórios?',
    confirmButtonText: 'ABRIR',
    cancelButtonText: 'NÃO ABRIR',
    requestClass: {
      solicit: () => Promise.resolve({}),
    },
    totalItens: 0,
  }),
  computed: {
    proxyRequest() {
      return (params = {}) => this.requestClass.solicit(params);
    },
    faultReportParams() {
      return {
        ignoreClientVaultTransactions: true,
      };
    },
    handleParams() {
      return (params) => ({
        request: {
          ignorePagination: true,
          reportType: 'Csv',
        },
        filter: {
          ...this.prepareParams(params),
          ...this.faultReportParams,
        },
      });
    },
  },
  methods: {
    prepareParams(params = {}) {
      const prepare = this.makeFirstToLowerCaseLetter(params);
      const override = {};
      Object.keys(prepare)
        .forEach(
          (key) => {
            const item = prepare[key];
            if (this.isValidValue(item)) {
              override[key] = item;
            }
          },
        );
      return override;
    },
    isValidValue(item) {
      if (typeof item === 'boolean') {
        return true;
      }
      if (Array.isArray(item) && item.length >= 1) {
        return true;
      }
      if (typeof item === 'object' && Object.keys(item).length >= 1) {
        return true;
      }
      if (typeof item === 'string' && item !== '') {
        return true;
      }
      return false;
    },
    makeFirstToLowerCaseLetter(params = {}) {
      return Object.keys(params)
        .reduce(
          (obj, key) => {
            const override = obj;
            const [firstLetter, ...letters] = key.split('');
            const letterKey = [firstLetter.toLowerCase(), ...letters].join('');
            override[letterKey] = params[key];

            return override;
          },
          {},
        );
    },
    confirmTerminate() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      const params = this.removePage(
        this.getParams,
      );
      this.proxyRequest(
        this.handleParams(
          params,
        ),
      )
        .then(
          this.confirmCallback,
        ).catch(
          (err) => {
            this.showErrorToast({
              text: err.response.data.message,
            });
          },
        ).finally(
          this.handleLoading,
        );
    },
    confirmCallback() {
      this.confirmacao(
        this.dialogTitle,
        this.dialogText,
        this.navigateToReports,
      );
    },
    navigateToReports() {
      this.navigateTo('manageReports.list');
    },
  },
};
</script>
